/**
 * Created by i.lovenkov on 25.04.17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Notification: {
        displayName: 'Notification'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Notification/Notification.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Notification = _wrapComponent('Notification')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        setting: state.setting,
        user: state.auth.user,
        lang: state.lang
    };
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Notification, _Component);

    function Notification(props) {
        (0, _classCallCheck3.default)(this, Notification);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Notification.__proto__ || (0, _getPrototypeOf2.default)(Notification)).call(this, props));

        _this.checkEmptyField = function () {
            var _this$props = _this.props,
                setting = _this$props.setting,
                user = _this$props.user;


            if (user) {
                var confirmed = user.confirmed;


                if (setting.additionalFieldSettings) {
                    var additionalFieldSettings = setting.additionalFieldSettings;


                    return additionalFieldSettings.some(function (item) {
                        var show_in_profile = item.show_in_profile,
                            typeAdditionalField = item.typeAdditionalField;


                        if (show_in_profile) {
                            if (typeAdditionalField.slug === 'phone') {
                                // данные поля в объекте confirmed называются по-другому
                                return !confirmed['confirmed_' + typeAdditionalField.slug];
                            } else if (typeAdditionalField.slug === 'email') {
                                // данные поля в объекте confirmed называются по-другому
                                return !confirmed['confirmed_' + typeAdditionalField.slug];
                            } else if (typeAdditionalField.slug === 'username') {
                                return !user.name;
                            } else {
                                return !confirmed[typeAdditionalField.slug];
                            }
                        }
                    });
                }

                return !user.name || !user.phone;
            }

            return false;
        };

        _this.onClick = function () {
            var onClick = _this.props.onClick;


            if (onClick) {
                onClick();
            }
        };

        return _this;
    }

    /**
     * Обработчик показа иконки нотификации
     * @returns {boolean}
     */


    (0, _createClass3.default)(Notification, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                iconClassName = _props.iconClassName,
                isLink = _props.isLink,
                lang = _props.lang;


            var View = _helpers.ThemeHelper.getViewForComponent('Notification');

            return this.checkEmptyField() ? _react3.default.createElement(View, {
                isLink: isLink,
                className: className,
                iconClassName: iconClassName,
                onClick: this.onClick,
                lang: lang
            }) : null;
        }
    }]);
    return Notification;
}(_react2.Component), _class2.propTypes = {
    className: _react2.PropTypes.string,
    iconClassName: _react2.PropTypes.string,
    onClick: _react2.PropTypes.func,
    setting: _react2.PropTypes.object.isRequired,
    user: _react2.PropTypes.object,
    isLink: _react2.PropTypes.bool,
    lang: _react2.PropTypes.object
}, _class2.defaultProps = {
    isLink: true
}, _temp)) || _class));

exports.default = Notification;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/Notification.jsx
// module id = 1695
// module chunks = 0